<!-- <div> -->
  <span #textElement class="title"></span>
  <span #blinkElement class="text blink">|</span>
<!-- </div> -->
